export const PreviewHeader = ({ children }: { children: React.ReactNode }) => {
  return <header className="preview__header">{children}</header>;
};
